type PayPhoneIconProps = {
  phoneNumber: string;
};

export const PayPhoneIcon = ({ phoneNumber }: PayPhoneIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="354"
    height="41"
    viewBox="0 0 354 41"
  >
    <g data-name="Groupe 16858">
      <g data-name="Rectangle 6360" stroke={"#a20f77"} fill={"#fff"}>
        <path stroke={"none"} d="M0 0h354v39H0z" transform="translate(0 1)" />
        <path fill={"none"} d="M.5.5h353v38H.5z" transform="translate(0 1)" />
      </g>
      <path
        data-name="Tracé 11990"
        d="M0 0h148v41H0V30.375l10-9.7-10-9.847z"
        transform="translate(196.645)"
        fill={"#a20f77"}
      />
    </g>
    <text
      transform="translate(214 18)"
      fontFamily={"OpenSans-Semibold,Open Sans"}
      fontWeight={"600"}
      fontSize={"13px"}
      fill={"#fff"}
    >
      <tspan x="0" y="0">
        Service 0,20 €/min
      </tspan>
      <tspan x="0" y="16">
        + prix appel
      </tspan>
    </text>
    <text
      data-name="Value"
      transform="translate(15 29)"
      fontSize={"21px"}
      fontFamily={"OpenSans-Semibold,Open Sans"}
      fontWeight={"600"}
      fill={"#a20f77"}
    >
      <tspan x="0" y="0">
        {phoneNumber}
      </tspan>
    </text>
  </svg>
);
